import { render, staticRenderFns } from "./utrecht.vue?vue&type=template&id=5a98eb61"
import script from "./utrecht.vue?vue&type=script&lang=js"
export * from "./utrecht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports